"use client";

import { formatUnits } from "viem";
import { Badge } from "@/components/ui/badge";

/**
 * Per-row yellow chip showing user's TOTAL voted DNM this cycle — Figma 5462:51908 (Phase 2).
 *
 * Q6 RESOLVED: same value on every row — this is the logged-in user's total,
 * NOT per-candidate. The hook call is hoisted to CandidateCard (parent).
 *
 * Visibility rules:
 *   - amount === undefined (loading / wallet disconnected) → null
 *   - amount === 0n (not voted yet) → null
 *   - amount > 0n → Badge with "{formatDnm(amount)} DNM"
 *
 * AC-21 (visibility), AC-22 (format).
 */

interface VotedDnmBadgeProps {
  amount: bigint | undefined;
}

/** Format bigint wei → decimal string, stripping trailing zeros. */
function formatDnm(wei: bigint): string {
  const formatted = formatUnits(wei, 18);
  return formatted.replace(/(\.\d*?)0+$/, "$1").replace(/\.$/, "");
}

export const VotedDnmBadge: React.FC<VotedDnmBadgeProps> = ({ amount }) => {
  if (amount === undefined || amount === 0n) {
    return null;
  }

  return (
    <Badge
      variant="default"
      className="rounded-md bg-accent/20 text-accent text-[10px] leading-[1.4] px-2 h-5 font-medium"
    >
      {formatDnm(amount)} DNM
    </Badge>
  );
};
